export const OPEN_MODAL_FORM = "OPEN_MODAL_FORM";
export const CLOSE_MODAL_FORM = "CLOSE_MODAL_FORM";
export const SAVE_LOCATIONS = "SAVE_LOCATIONS";
export const DELETE_LOCATION = "DELETE_LOCATION";
